import script from "./PartnerProjectReport.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjectReport.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjectReport.vue?vue&type=style&index=0&id=bd8e32a6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd8e32a6"]])

export default __exports__